import Checkers from "../../../../helpers/class/Checkers";
import {Swipe} from "@mui/icons-material";
import {Swiper, SwiperSlide} from "swiper/react";
import Image from "next/image";
import React, {FC, ReactComponentElement} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft as fasAngleLeft, faAngleRight as fasAngleRight} from "@fortawesome/pro-solid-svg-icons";
import {faClose as farClose} from "@fortawesome/pro-regular-svg-icons";
import {AnyComponent} from "styled-components/native/dist/types";

interface ContentWrapperProps {
    ContentRender: ReactComponentElement<AnyComponent>
}
const ContentWrapper = ({ContentRender} : ContentWrapperProps) => {

    return (
        <>
            {ContentRender}
        </>
    )
}

export default ContentWrapper